import React, { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { authForgot, authReset } from "../../lib/api";
import { Shell, Card, H1, Field, Btn } from "./ui";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await authForgot(email); } catch {}
    setSent(true);
  };
  return (
    <Shell>
      <div className="max-w-md mx-auto mt-16">
        <H1>Reset your password</H1>
        <Card className="mt-6">
          {sent ? (
            <p className="text-sm text-white/70" data-testid="forgot-sent">If an account exists for <b>{email}</b>, a reset link has been sent. Check your inbox.</p>
          ) : (
            <form onSubmit={submit} data-testid="forgot-form">
              <Field label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" required />
              <Btn type="submit" data-testid="forgot-submit" className="w-full mt-2">Send reset link</Btn>
            </form>
          )}
          <div className="mt-4 text-xs"><Link to="/login" className="text-white/50 hover:text-[#00D26A]">Back to sign in</Link></div>
        </Card>
      </div>
    </Shell>
  );
}

export function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await authReset(token, password);
      toast.success("Password updated — please sign in");
      nav("/login", { replace: true });
    } catch (er) {
      toast.error(er?.response?.data?.detail || "This reset link is invalid or expired");
    } finally { setBusy(false); }
  };
  return (
    <Shell>
      <div className="max-w-md mx-auto mt-16">
        <H1>Choose a new password</H1>
        <Card className="mt-6">
          <form onSubmit={submit} data-testid="reset-form">
            <Field label="New password (min 8 chars)" type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" required />
            <Btn type="submit" disabled={busy} data-testid="reset-submit" className="w-full mt-2">{busy ? "Saving…" : "Update password"}</Btn>
          </form>
        </Card>
      </div>
    </Shell>
  );
}
